/* src/app/core/loading/loading.component.scss */
.spinner-container {
  position: fixed;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 50px;
  left: 27px;
  z-index: 6000;
}
.spinner-white {
  color: var(--foreground);
  font-size: 20px;
}
/*# sourceMappingURL=loading.component-AFTQ76HA.css.map */
